import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CanComponentDeactivate } from 'src/app/shared/guards/can-deactivate.guard';
import { ApiErrorResponse } from 'src/app/shared/interfaces/api-error-response';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { SubSink } from 'subsink';

import {
  MerchantAccountActions,
  MerchantAccountSelectors,
} from '@app/merchant-account/store/merchant-account.slice';
import {
  getServerErrorForField,
  processErrorResponse,
} from '@shared/helpers/form-helper';
import { trimInput } from '@shared/helpers/input-trim-helper';
import { isValidEmail } from '@shared/validators/email.validator';
import { isPhoneNumber } from '@shared/validators/phone-number.validator';

@Component({
  selector: 'app-user-creation',
  templateUrl: './user-creation.component.html',
  styleUrls: ['./user-creation.component.scss'],
})
export class UserCreationComponent
  implements OnDestroy, OnInit, CanComponentDeactivate
{
  errorResponse$: Observable<ApiErrorResponse | undefined> = this.store.select(
    MerchantAccountSelectors.selectCreateMerchantAdminErrorResponse
  );

  roleList: string[] = [
    'PRODUCT_ADMIN',
    'PRICING_ADMIN',
    'MERCHANT_ADMIN',
    'COMMERCIAL_ADMIN',
    'EXCISE_MANAGER',
    'SUBSCRIPTION_ADMIN',
    'SETTINGS_ADMIN',
    'USER_ADMIN',
    'SUPPLY_MANAGER',
  ];

  form: UntypedFormGroup = this.fb.group({
    lastName: new UntypedFormControl(null, [Validators.required]),
    firstName: new UntypedFormControl(null, [Validators.required]),
    email: new UntypedFormControl(null, [Validators.required, isValidEmail]),
    phoneNumber: new UntypedFormControl(null, [
      Validators.required,
      isPhoneNumber,
    ]),
    roles: new UntypedFormControl(null, [Validators.required]),
  });

  private subs = new SubSink();

  ngOnInit() {
    this.subs.sink = this.errorResponse$.subscribe((response) =>
      processErrorResponse(this.form, response)
    );
  }
  constructor(
    private store: Store,
    private fb: UntypedFormBuilder,
    private readonly dialogService: DialogService
  ) {}

  onSubmit() {
    if (this.form.valid) {
      this.form.markAsPristine();
      this.store.dispatch(
        MerchantAccountActions.createMerchantAdmin.trigger(
          trimInput(this.form.value)
        )
      );
    }
  }

  getServerError(fieldName: string): any {
    return getServerErrorForField(this.form, fieldName);
  }

  get emailControl(): UntypedFormControl {
    return this.form.get('email') as UntypedFormControl;
  }

  canDeactivate() {
    return this.form.dirty ? this.dialogService.confirmUnsavedChanges() : true;
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
